import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyPhone from "@/pages/VerifyPhone";
import GoogleCallback from "@/pages/GoogleCallback";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Fees from "@/pages/legal/Fees";
import PaymentCallback from "@/pages/PaymentCallback";
import AdminLogin from "@/pages/AdminLogin";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordFlows";
import MasterClientKyc from "@/pages/onboarding/MasterClientKyc";
import ReferralClientKyc from "@/pages/onboarding/ReferralClientKyc";
import ReferrerKyc from "@/pages/onboarding/ReferrerKyc";
import ProviderKyc from "@/pages/onboarding/ProviderKyc";
import MasterClientDashboard from "@/pages/dashboard/MasterClientDashboard";
import { ReferralClientDashboard, ReferrerDashboard } from "@/pages/dashboard/OtherDashboards";
import ProviderDashboard from "@/pages/dashboard/ProviderDashboard";
import { Beneficiaries, Witnesses } from "@/pages/ClientRecords";
import { Marketplace, ProviderDetail } from "@/pages/Marketplace";
import { ClientBookings } from "@/pages/Bookings";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AcceptInvite from "@/pages/AcceptInvite";

const R = {
  MC: "MASTER_CLIENT",
  RC: "REFERRAL_CLIENT",
  RF: "REFERRER",
  SP: "SERVICE_PROVIDER",
  A: "ADMIN",
  SA: "SUPER_ADMIN",
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="/auth/google" element={<GoogleCallback />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/fees" element={<Fees />} />
          <Route path="/payment/callback" element={<ProtectedRoute><PaymentCallback /></ProtectedRoute>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/verify-phone" element={<ProtectedRoute requirePhone={false}><VerifyPhone /></ProtectedRoute>} />

          <Route path="/onboarding/master-client" element={<ProtectedRoute roles={[R.MC]}><MasterClientKyc /></ProtectedRoute>} />
          <Route path="/onboarding/referral-client" element={<ProtectedRoute roles={[R.RC]}><ReferralClientKyc /></ProtectedRoute>} />
          <Route path="/onboarding/referrer" element={<ProtectedRoute roles={[R.RF]}><ReferrerKyc /></ProtectedRoute>} />
          <Route path="/onboarding/provider" element={<ProtectedRoute roles={[R.SP]}><ProviderKyc /></ProtectedRoute>} />

          <Route path="/dashboard/master-client" element={<ProtectedRoute roles={[R.MC]}><MasterClientDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/referral-client" element={<ProtectedRoute roles={[R.RC]}><ReferralClientDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/referrer" element={<ProtectedRoute roles={[R.RF]}><ReferrerDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/service-provider" element={<ProtectedRoute roles={[R.SP]}><ProviderDashboard /></ProtectedRoute>} />

          <Route path="/beneficiaries" element={<ProtectedRoute roles={[R.MC]}><Beneficiaries /></ProtectedRoute>} />
          <Route path="/witnesses" element={<ProtectedRoute roles={[R.MC]}><Witnesses /></ProtectedRoute>} />
          <Route path="/bookings" element={<ProtectedRoute roles={[R.MC]}><ClientBookings /></ProtectedRoute>} />
          <Route path="/marketplace" element={<ProtectedRoute roles={[R.MC, R.RC, R.A, R.SA]}><Marketplace /></ProtectedRoute>} />
          <Route path="/marketplace/:id" element={<ProtectedRoute roles={[R.MC, R.RC, R.A, R.SA]}><ProviderDetail /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute roles={[R.A, R.SA]}><AdminDashboard /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
